import { normalizeCampaignSlug } from './slug';
import type { PayloadBuilderState } from './types';

export function isStatusClaimPayloadComplete(state: PayloadBuilderState): boolean {
  return Boolean(
    state.campaignId.trim() &&
      normalizeCampaignSlug(state.slug) &&
      state.heroTitle.trim() &&
      state.heroSubtitle.trim() &&
      state.heroImageId.trim() &&
      state.termsSlug.trim() &&
      state.partnerName.trim() &&
      state.partnerLogoImageId.trim() &&
      state.tiersGranted.length > 0,
  );
}
